import { Col, Container,Row } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css"; 
import meter1 from "../assests/img/meter1.svg";
import meter2 from "../assests/img/meter2.svg";
import meter3 from "../assests/img/meter3.svg";
import colorSharp from "../assests/img/color-sharp.png";

export const Skills = () => {
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
      };

      return (
        <section className="skill" id="skills">
          <Container>
            <Row>
                <Col>
                <div className="skill-bx">
                   <h2>
                    Skills
                    </h2>
                    <p>I have experience in web development, data analysis, natural language processing (NLP), and machine learning. I'm proficient with tools like React, TensorFlow, Keras, and Python, and also skilled in UI/UX design using Figma and Adobe XD. My expertise extends to creating interactive websites, analyzing large datasets, and developing intelligent models for real-world applications.</p>
                     <Carousel responsive={responsive} infinite={true} className="skill-slider">
                        <div className="item">
                            <img src={meter1} alt="Image" />
                            <h5> Frontend Web Development</h5>
                        </div>
                        <div className="item">
                            <img src={meter2} alt="Image" />
                            <h5>Data Analytics</h5>
                        </div>
                        <div className="item">
                            <img src={meter3} alt="Image" />
                            <h5>UI/UX Design</h5>
                        </div>
                        <div className="item">
                            <img src={meter1} alt="Image" />
                            <h5>DSA using C++</h5>
                        </div>
                     </Carousel>
                </div>
                </Col>
            </Row>
          </Container>
          <img className="background-image-left" src={colorSharp} />
        </section>
      )


}
